// Shared page chrome used by both the full validator (main.ts) and the
// lightweight package-check page (package-main.ts): the light/dark theme
// toggle and the footer version identifiers.

import { fetchValidatorVersion } from "./api.js";

export function initTheme(): void {
  const themeBtn = document.getElementById("theme-toggle") as HTMLButtonElement | null;
  const saved = localStorage.getItem("wpv-dark");
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const dark = saved === null ? prefersDark : saved === "1";
  applyTheme(dark, themeBtn);

  themeBtn?.addEventListener("click", () => {
    const isDark = document.documentElement.getAttribute("data-theme") === "dark";
    applyTheme(!isDark, themeBtn);
    localStorage.setItem("wpv-dark", !isDark ? "1" : "0");
  });
}

function applyTheme(dark: boolean, themeBtn: HTMLButtonElement | null): void {
  document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
  if (themeBtn) themeBtn.innerHTML = dark ? sunIcon() : moonIcon();
}

function sunIcon(): string {
  return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>`;
}

function moonIcon(): string {
  return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>`;
}

export function initVersionFooter(): void {
  const websiteIdEl = document.getElementById("website-id");
  const validatorIdEl = document.getElementById("validator-id");
  if (websiteIdEl) websiteIdEl.textContent = __WEBSITE_ID__;
  if (validatorIdEl) {
    fetchValidatorVersion()
      .then((v) => {
        validatorIdEl.textContent = shortId(v.id);
        if (v.timestamp) validatorIdEl.title = `Deployed ${v.timestamp}`;
      })
      .catch(() => {
        validatorIdEl.textContent = "unknown";
      });
  }
}

function shortId(id: string): string {
  if (!id || id === "dev") return id || "dev";
  return id.length > 8 ? id.slice(0, 8) : id;
}
